import { AddressSearchWidget } from '@melio/ap-widgets';
import { Form, Group, useBreakpoint } from '@melio/penny';
import { useAnalyticsView } from '@melio/platform-analytics';
import { useMelioIntl } from '@melio/platform-i18n';

import { RegisterFormField } from './types';

export const EBillsSusbscriptionFormEditCompany = ({ registerField }: { registerField: RegisterFormField }) => {
  const { formatMessage } = useMelioIntl();
  const { isExtraSmallScreen } = useBreakpoint();

  useAnalyticsView('subscribe-to-ebills-and-edit');

  return (
    <Group variant="vertical" spacing="l">
      <Group variant={isExtraSmallScreen ? 'vertical' : 'horizontal'} width="full" justifyContent="space-between">
        <Form.TextField
          {...registerField('name.firstName')}
          labelProps={{ label: formatMessage('activities.ebillsSubscriptionForm.form.fields.firstName.label') }}
          isRequired
        />
        <Form.TextField
          width={isExtraSmallScreen ? 'full' : '80px'}
          {...registerField('name.middleName')}
          labelProps={{ label: formatMessage('activities.ebillsSubscriptionForm.form.fields.middleName.label') }}
        />
        <Form.TextField
          {...registerField('name.lastName')}
          labelProps={{ label: formatMessage('activities.ebillsSubscriptionForm.form.fields.lastName.label') }}
          isRequired
        />
      </Group>
      <AddressSearchWidget
        {...registerField('address')}
        labelProps={{ label: formatMessage('activities.ebillsSubscriptionForm.form.fields.address.label') }}
        isRequired
      />
    </Group>
  );
};
